import { RecordString } from '../../types/record.type';

export enum IAuthStep {
  phone = 'phone',
  email = 'email',
  code = 'code',
}

export type IPhoneForm = RecordString<'phone'>;
export type IEmailForm = RecordString<'email'>;
export type IVerificationCodeForm = RecordString<'code'>;

export type IValidationCodeForm = (IPhoneForm | IEmailForm) & IVerificationCodeForm;
